
import { Form } from "element-ui";
import Vue from "vue";
import { login } from "@/service/ewold/api/user";
export default Vue.extend({
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入登录帐号/手机号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      submitting: false,
    };
  },
  methods: {
    validate() {
      const form = this.$refs.form as Form;
      return form.validate();
    },
    async submit() {
      const valid = await this.validate().catch(() => false);
      if (!valid) {
        return;
      }
      this.submitting = true;
      const res = await login({
        user_name: this.form.username,
        password: this.form.password,
      });
      this.submitting = false;
      const success = res.is_success && typeof res.result === "string";
      if (success) {
        const token = res.result;
        this.$cookies.set("ewoldAuthToken", token);
        this.$router.back();
      }
    },
  },
});
